import React from "react";
import { formatCurrency } from "../../UI/DesignStandards";
import { yearAttention } from "../../../utility/organizationYear";

const YearAttentionStrip = ({ rollup }) => {
  const items = yearAttention(rollup);
  if (!items.length) return null;

  return (
    <div className="border border-brand-charcoal/10 rounded-lg px-4 py-3">
      <dl className="grid grid-cols-2 sm:grid-cols-3 gap-x-6 gap-y-3">
        {items.map((item) => (
          <div key={item.key}>
            <dt className="text-sm text-brand-muted">{item.label}</dt>
            <dd className="font-score text-xl font-semibold text-brand-charcoal">
              {item.amount != null ? formatCurrency(item.amount) : item.count}
            </dd>
            {item.amount != null && item.count > 0 ? (
              <p className="text-sm text-brand-muted">{item.count}</p>
            ) : null}
          </div>
        ))}
      </dl>
    </div>
  );
};

export default YearAttentionStrip;
